<template>
  <section-box class="lead_section_box">
    <div class="lead_section_box--header">
      <div
        :class="['lead_section_box--title', {'collapseable': collapseable}]"
        @click="toggleSection"
      >
        <div
          v-if="collapseable"
          :class="['lead_section_box--toggle', {'expanded': showExpandedSection}]"
        >
          <icon-default icon="collapseToggle"></icon-default>
        </div>

        <h3 class="flex-grow text-uppercase">{{ title }}<span v-if="subTitle"> ({{ subTitle }})</span></h3>
      </div>

      <div class="flex flex-wrap flex-end">
        <button-outlined
          v-if="secondButtonText && !hideSecondButton"
          :class="['lead_section_box--button', {'mb-50': isMobile}]"
          @click="$emit('secondButtonClick', $event)"
        >
          {{ secondButtonText }}
        </button-outlined>

        <button-outlined
          v-if="buttonText"
          class="lead_section_box--button ml-50"
          :icon-left="buttonIcon"
          @click="$emit('add', $event)"
        >
          {{ buttonText }}
        </button-outlined>
      </div>

      <div
        v-if="editable"
        class="lead_section_box--edit"
        @click="$emit('edit', $event)"
      >
        <icon-default icon="edit" size="is-small"></icon-default>
      </div>
    </div>

    <div v-show="showInitial" :class="['lead_section_box--body', {'is-loading': isLoading}]">
      <app-loading-section
        :loading="isLoading"
      >
        <slot></slot>
      </app-loading-section>
    </div>

    <div v-show="showExpandedSection" :class="['lead_section_box--body', {'is-loading': isLoading}]">
      <app-loading-section
        :loading="isLoading"
      >
        <slot name="expanded"></slot>
      </app-loading-section>
    </div>
  </section-box>
</template>

<script>
export default {
  name: "SectionCollapseable",
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: [String, Number],
    },
    buttonText: {
      type: String,
    },
    secondButtonText: {
      type: String,
    },
    hideButtonIcon: {
      type: Boolean,
      default: false
    },
    hideSecondButton: {
      type: Boolean,
      default: false
    },
    collapseable: {
      type: Boolean,
      default: false,
    },
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false
    },
    hideInitialWhenExpanded: {
      type: Boolean,
      default: false
    },
    hideInitialAlways: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showExpandedSection: this.defaultExpanded,
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    showInitial() {
      if(this.hideInitialAlways) {
        return false;
      }

      if(!this.hideInitialWhenExpanded) {
        return true;
      } else {
        return !this.showExpandedSection
      }
    },
    buttonIcon() {
      if(this.hideButtonIcon) {
        return null;
      } else {
        return 'plus'
      }
    }
  },
  methods: {
    toggleSection() {
      if(this.collapseable) {
        this.showExpandedSection = !this.showExpandedSection;

        this.$emit('toggled', this.showExpandedSection);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.lead_section_box {
  margin-bottom: $modalGutter;
  padding: 0.5rem 0.75rem;

  &--header {
    display: flex;
    align-items: center;

    //@include mobile {
    //  flex-wrap: wrap;
    //  justify-content: end;
    //}
  }

  &--title {
    display: flex;
    align-items: center;
    flex-grow: 1;
    margin-right: 8px;

    &.collapseable {
      cursor: pointer;

      &:hover {
        h3 {
          color: $link-hover;
        }

        .lead_section_box--toggle {
          color: $link-hover;
        }
      }
    }

    h3 {
      size: $size-5;

      span {
        color: $text-light;
        text-transform: lowercase;
      }
    }
  }

  &--toggle {
    margin-right: 2px;
    color: $text-muted;
    transition: all 0.2s;

    &.expanded {
      transform: rotate(180deg);
    }
  }

  &--button {
    height: 1.5rem;
    padding: 0 0.5rem;
    line-height: 1;
  }

  &--edit {
    margin-left: 8px;
    color: $link;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }

  &--body {
    position: relative;
    padding: 0.5rem 0;

    &.is-loading {
      min-height: 100px;
    }
  }
}

</style>
